export const getEvenlySpacedYears = (
  propertyValueChart: any,
  activePosition: 10 | 20 | 30,
  count: number
) => {
  const years = propertyValueChart.totalPropertyValueByYear
    .filter((item: any) => item.yearIndex <= activePosition)
    .map((item: any) => item.year);

  if (years.length <= count) return years; // если элементов мало — вернуть как есть

  const result = [];
  const step = (years.length - 1) / (count - 1);

  for (let i = 0; i < count; i++) {
    const index = Math.round(i * step);
    result.push(years[index]);
  }

  return Array.from(new Set(result)); // убрать возможные дубликаты при округлении
};

export const getChartData = (propertyValueChart: any, activePosition: 10 | 20 | 30) => {
  return propertyValueChart.totalPropertyValueByYear
    .filter((item: any) => item.yearIndex <= activePosition)
    .map((item: any) => ({
      x: item.year,
      y: item.value,
    }));
};
